module.exports = __webpack_public_path__ + "img/logo-white.7449b4e8.svg";